/**
 * Toast (https://github.com/itchief/ui-components/tree/master/toast)
 * Copyright 2020 - 2021 Alexander Maltsev
 * Licensed under MIT (https://github.com/itchief/ui-components/blob/master/LICENSE)
 **/

class Toast {
    constructor(params) {
        this._id = params['id'] || false;
        this._title = params['title'] === false ? false : params['title'] || 'Title';
        this._text = params['text'] || 'Message...';
        this._theme = params['theme'] || 'default';
        this._autohide = params['autohide'] && true;
        this._interval = +params['interval'] || 5000;
        this._create();
        this._el.addEventListener('click', (e) => {
            if (e.target.classList.contains('toast__close')) {
                const event = new CustomEvent('close.toast', {detail: {target: this._el}});
                document.dispatchEvent(event);
                
                this._hide();
            }
        });
        this._show();
    }

    _show() {
        this._el.classList.add('toast_showing');
        this._el.classList.add('toast_show');
        window.setTimeout(() => {
            this._el.classList.remove('toast_showing');
        });
        if (this._autohide) {
            setTimeout(() => {
                this._hide();
            }, this._interval);
        }
    }

    _hide() {
        this._el.classList.add('toast_showing');
        this._el.addEventListener('transitionend', () => {
            this._el.classList.remove('toast_showing');
            this._el.classList.remove('toast_show');
            this._el.remove();
        }, {once: true});
        const event = new CustomEvent('hide.toast', {detail: {target: this._el}});
        document.dispatchEvent(event);
    }

    _create() {
        const el = document.createElement('div');
        if (this._id) {
            el.id = this._id;
        }
        el.classList.add('toast');
        el.classList.add(`toast_${this._theme}`);
        let html = `{header}<div class="toast__body"></div><button class="toast__close" type="button"></button>`;
        const htmlHeader = this._title === false ? '' : '<div class="toast__header"></div>';
        html = html.replace('{header}', htmlHeader);
        el.innerHTML = html;
        if (this._title) {
            el.querySelector('.toast__header').textContent = this._title;
        } else {
            el.classList.add('toast_message');
        }
        el.querySelector('.toast__body').innerHTML = this._text;
        this._el = el;
        if (!document.querySelector('.toast-container')) {
            const container = document.createElement('div');
            container.classList.add('toast-container', 'site-bottom-wrapper__toast-container');
            document.body.append(container);
        }
        document.querySelector('.toast-container').append(this._el);
    }
}

(function () {
    $(function () {
        
        // Для уведомлений на определенных страницах
        const pathname = window.location.pathname;
        
        // Показ уведомления о неоплаченных заказах
        (function () {
            
            if ('hasUnpaidOrder' in window) {
                let showNotifyUnpaidOrder = false;
                if ('localStorage' in window) {
                    let hit = parseInt(window.localStorage.getItem('showNotifyUnpaidOrder'));
                    if (isNaN(hit)) {
                        hit = 1;
                    }
                    if (hit > 0 && !(hit % 5)) {
                        hit = 0;
                        showNotifyUnpaidOrder = true;
                    }
                    hit++;
                    window.localStorage.setItem('showNotifyUnpaidOrder', hit.toString());
                } else {
                    let hit = parseInt($.cookie('__snuo'));
                    if (isNaN(hit)) {
                        hit = 1;
                    }
                    if (hit > 0 && !(hit % 5)) {
                        hit = 0;
                        showNotifyUnpaidOrder = true;
                    }
                    hit++;
                    $.cookie('__snuo', hit.toString());
                }
                if (showNotifyUnpaidOrder) {
                    if('title' in window.hasUnpaidOrder && 'text' in window.hasUnpaidOrder && 'autoHide' in window.hasUnpaidOrder){
                        new Toast({
                            title: window.hasUnpaidOrder.title,
                            text: window.hasUnpaidOrder.text,
                            theme: 'light',
                            autohide: !!window.hasUnpaidOrder.autoHide,
                            interval: window.hasUnpaidOrder.autoHide
                        });
                    }
                }
            }
        }());
        
    
        // Показ уведомления о необходимости слияния аккаунтов
        (function () {
            
            if ('needMergeAccounts' in window && $.cookie('noRemindAboutMerge') === '1' && $.cookie('noToastAboutMerge') !== '1') {
                const toastId = 'mergeAccountsToast';
                new Toast({
                    title: 'Дубликаты аккаунтов',
                    text: '<div>Похоже, мы&nbsp;нашли дубликаты аккаунтов. Вы&nbsp;можете объединить их&nbsp;в&nbsp;личном кабинете.</div><div class="pay_link"><a class="link-txt _red _t-semibold js-merge-accounts-open" href="javascript:;">Подробнее</a></div>',
                    theme: 'light',
                    autohide: false,
                    interval: 5000,
                    id: toastId
                });
                document.addEventListener('close.toast', function(event) {
                    if (event.detail.target.id === toastId) {
                        // по этой куке отменяется показ тоаста
                        $.cookie('noToastAboutMerge', '1', {expires: 30, path: '/'});
                    }
                })
            }
        }());
    
    
        // Показ уведомления через месяц после отказа от заполнения почты
        (function () {
    
            if ((pathname === '/'
                || pathname.startsWith('/catalog/')
                || pathname.startsWith('/ebookcatalog/')
                || pathname.startsWith('/audiobookcatalog/')
                || pathname.startsWith('/search/'))) {
    
                if ('isNeedShowEmailPopup' in window.user && window.user.isNeedShowEmailPopup) {
                    const toastId = 'collectEmailToast';
                    new Toast({
                        title: 'Заполните данные профиля',
                        text: '<div>Укажите адрес вашей эл.&nbsp;почты, чтобы получать новости о&nbsp;новинках и&nbsp;промокоды' +
                            ' на&nbsp;скидки. Мы&nbsp;также начислим вам <span class="bonus-badge ui-tooltip" data-tooltip-type="bonus" data-tooltip-z-index="99999"><span class="bonus-badge__val" data-type="value">300&nbsp;руб.</span></span>,<br>' +
                            ' которые можно использовать для оплаты первого заказа.</div><div class="pay_link"><a class="link-txt _red _t-semibold js-ab-email-collector-notify-action" href="javascript:;">Заполнить почту</a></div>',
                        theme: 'light',
                        autohide: false,
                        interval: 5000,
                        id: toastId
                    });
                }
            }
            
            
        }());
    
    
        // Показ уведомления, если не заполнена дата рождения
        (function () {
    
            if ((pathname === '/'
                || pathname.startsWith('/catalog/')
                || pathname.startsWith('/ebookcatalog/')
                || pathname.startsWith('/audiobookcatalog/')
                || pathname.startsWith('/search/'))) {
    
                if (window.user.userLogged && !window.user.userBirthday && $.cookie('ab_is_toast_birthday_disabled') !== '1') {
                    const toastId = 'collectBirthdayToast';
                    new Toast({
                        title: 'Расскажите, когда сделать вам подарок',
                        text: '<div>Укажите вашу дату рождения, чтобы мы начислили вам <span class="bonus-badge ui-tooltip" data-tooltip-type="bonus" data-tooltip-z-index="99999"><span class="bonus-badge__val" data-type="value">500&nbsp;руб.</span></span> за две недели до праздника.</div>' +
                            '<div class="pay_link"><a class="link-txt _red _t-semibold" href="/personal/profile/" target="_blank">Указать</a></div>',
                        theme: 'light',
                        autohide: false,
                        interval: 5000,
                        id: toastId
                    });
                    document.addEventListener('close.toast', function(event) {
                        if (event.detail.target.id === toastId) {
                            // по этой куке отменяется показ тоаста
                            $.cookie('ab_is_toast_birthday_disabled', '1', {expires: 30, path: '/'});
                        }
                    })
                }
            }
        }());
    })
}());
